
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/la-radio",
      function () {
        return require("private-next-pages/la-radio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/la-radio"])
      });
    }
  